<template>
  <!-- 扫码先进这里埋点，根据fairId拿详情再跳转 -->
  <div class="job-fair-detail">
  </div>
</template>


<script>
import {
  getJobFairDetail,
  addRecommendEffectMonitoring
} from '@/api/rd.js'
export default {
  data () {
    return {
    }
  },
  async created () {
    const query = this.$route.query
    if (query.jobFairId) {
      if (query.id && query.qrCode) {
        addRecommendEffectMonitoring(
          {
            recommendId: query.id,
            jobFairId: query.jobFairId,
            sourceCode: '双选会-扫码'
          }
        )
      }
      const jobRes = await getJobFairDetail({ jobFairId: query.jobFairId, id: this.$route.query.id })
      if (jobRes.data.success) {
        if (jobRes.data.data.customizationFairUrl) {
          window.location.href = jobRes.data.data.customizationFairUrl
        } else {
          window.location.href = `https://zhaopin.com/sxh/${query.jobFairId}`
        }
      } else {
        this.$notify({
          type: "warning",
          message: jobRes.data.apiErrorMessage,
          duration: 3 * 1000,
        });
        if (jobRes.data.errorCode === 421) {
          this.$router.push({
            name: '404'
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
